<template>
  <component :is="component" :tabIndex="tabIndex" />
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import iframe from '~/components/iframe.vue';
// eslint-disable-next-line import/no-unresolved
import desktop from '~/components/desktop/numbergame.vue';

export default {
    extends: iframe,
    components: {
        desktop
    },
    head() {
        return {};
    },
    data() {
        return {
            tabIndex: this.$getRoute(this.$route).path
        };
    },
    computed: {
    },
    methods: {
    },
    mounted() {
    },
    async asyncData({ app, store }) {
        const res = await app.$urlApi.getMaintenance();
        if (res.status === 'OK' && res.data.enable) {
            store.dispatch('updateMaintenance', res.data);
        }
    }
};
</script>
